(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pack-selector-component')) {
    class PackSelectorComponent extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        this.addEventListener('change', (event) => {
          const radio = event.target;
          if (!radio.matches('[data-pack-radio]')) return;
          const idInput = this.querySelector('input[name="id"]');
          if (idInput) idInput.value = radio.value;
          const link = this.closest('product-card')?.querySelector('.product-card__link');
          const url = radio.closest('[data-variant-url]')?.dataset.variantUrl;
          if (link && url) link.setAttribute('href', url);
        });
      }
    }
    customElements.define('pack-selector-component', PackSelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
